import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { QuestionService } from '@app/shared/services/questions/question.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-create-intent',
  templateUrl: './dialog-create-intent.component.html',
  styleUrls: ['./dialog-create-intent.component.scss'],
})
export class DialogCreateIntentComponent implements OnInit {
  nameInput: string;
  loading: boolean;

  constructor(
    private questionService: QuestionService,
    private router: Router,
    public dialogRef: MatDialogRef<DialogCreateIntentComponent>
  ) { }

  ngOnInit() {
    // this.router.navigate(['/gx/questions/intent/', '12345']);
  }

  okClicked() {
    this.loading = true;
    this.questionService.createIntent(this.nameInput).subscribe((res: any) => {
      if (res.data) {
        this.router.navigate(['/gx/questions/intent/', res.data.uuid]);
        this.loading = false;
        this.dialogRef.close();
      }

      if (res.error) {
        this.loading = false;
      }
    });
  }
}
